<template>
    <div class="container">
        <MercenaryHeader :title="'선수 유형 선택'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }" />
        <div class="content_container">
            <div class="title">선수 유형 선택</div>
            <div class="sub_title">지원 목적에 따라 입력 항목이 달라집니다</div>
            <div class="type_container">
                <div @click="selectType(TYPE.ELITE)" :class="{ 'selected_elite': selectedType === TYPE.ELITE }" class="type_box">
                    <div style="flex-shrink: 0;">
                        <div class="box_type_title">엘리트 선수</div>
                        <div class="box_type_description">진학·이적을 고민 중인<br> <span class="highlight_elite">엘리트 선수 전용</span> 공식 제안 공간</div>
                        <div class="check_container_wrapper">
                            <div class="check_container">
                                <img class="check_img" :src="require('@/assets/img/elite_check.png')" alt="">
                                <div class="check_text">1종 또는 2종팀에서 뛰어본 경험이 있는 선수</div>
                            </div>
                            <div class="check_container">
                                <img class="check_img" :src="require('@/assets/img/elite_check.png')" alt="">
                                <div class="check_text">현재 소속팀에서 이적을 하고 싶은 선수</div>
                            </div>
                            <div class="check_container">
                                <img class="check_img" :src="require('@/assets/img/elite_check.png')" alt="">
                                <div class="check_text">진학이 잘 되지 않는 선수</div>
                            </div>
                        </div>
                    </div>
                    <div class="type_box_image">
                        <img style="width: 100%; max-width: 72px;" :src="require('@/assets/img/elite_img.png')" alt="">
                    </div>
                </div>
                <div @click="selectType(TYPE.CHALLENGER)" :class="{ 'selected_challenger': selectedType === TYPE.CHALLENGER }" class="type_box">
                    <div style="flex-shrink: 0;">
                        <div class="box_type_title">일반 선수</div>
                        <div class="box_type_description">아직 기회가 없었지만<br> <span class="highlight_challenger">한 번 도전해보고 싶은 학생</span> 을 위한 공간</div>
                        <div class="check_container_wrapper">
                            <div class="check_container">
                                <img class="check_img" :src="require('@/assets/img/challenger_check.png')" alt="">
                                <div class="check_text">취미로만 축구를 해 온 학생</div>
                            </div>
                            <div class="check_container">
                                <img class="check_img" :src="require('@/assets/img/challenger_check.png')" alt="">
                                <div class="check_text">축구선수를 목표로 처음 도전하는 학생</div>
                            </div>
                            <div class="check_container">
                                <img class="check_img" :src="require('@/assets/img/challenger_check.png')" alt="">
                                <div class="check_text">체계적인 축구 훈련을 받아보고 싶은 학생</div>
                            </div>
                        </div>
                    </div>
                    <div class="type_box_image">
                        <img style="width: 100%; max-width: 69px;" :src="require('@/assets/img/challenger_img.png')" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="footer_container">
            <div style="display: flex; align-items: flex-start; gap: 5px;">
                <div style="width: 16px; flex-shrink: 0; margin-top: 3px; height: 16px; border-radius: 50%; border: 2px solid #808080; color: #808080; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center;">
                    !
                </div>
                <div style="font-size: 12px; line-height: 20px; font-weight: 500; color: #606060;">정확한 구단 매칭을 위해 본인의 상황에 맞는 유형을 솔직하게 선택해 주세요.</div>
            </div>
            <div @click="authenticateParent" :class="{ 'active_footer_btn': selectedType !== '' }" class="footer_btn">{{btn_name}}</div>
        </div>
    </div>
</template>

<script>
export const TYPE = {
    ELITE: 'elite',
    CHALLENGER: 'challenger'
}

const CUR_TYPE = {
    COMMON: 0,
    SECRET: 1
}

import MercenaryHeader from '@/components/common/MercenaryHeader'

export default {
    name: 'SelectPlayerType',
    components: { MercenaryHeader },
    props: {
        requestType: {
            type: Number,
            default: CUR_TYPE.COMMON,
        },
        isElite: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (this.isElite) {
            this.selectedType = TYPE.ELITE;
        }
        this.getParentExist();
    },
    data() {
        return {
            selectedType: '',
            TYPE: TYPE,
            CUR_TYPE: CUR_TYPE,
            is_family_exist: false
        }
    },
    computed : {
        btn_name(){
            // return '입단 요청서 작성하기'
            if(this.$GlobalStore.loginInfo().is_adult){
                return '작성하기';
            } else if(this.is_family_exist){ //부모 인증 완료한경우
                return '작성하기';
            } else {
                return '부모님 인증 받기';
            }
        }
    },
    methods: {
        writeRequestForm(){
            if (this.selectedType === '') {
                this.$GlobalStore.showAlert('선수 유형을 선택해주세요');
                return;
            }
            // this.showWriteDefulatInfoForm();
            if (this.selectedType === TYPE.CHALLENGER) {
                this.$GlobalStore.addModal('RequestFormGuide', { playerType: this.selectedType, writeRequestForm: this.showWriteDefulatInfoForm });
            } else {
                this.showWriteDefulatInfoForm();
            }
        },
        async getParentExist(){
            const res = await this.$Axios.get('/api/member/family/exist');
            this.is_family_exist = res.data.is_family_exist;
        },
        authenticateParent() {
            if (this.selectedType === '') {
                this.$GlobalStore.showAlert('선수 유형을 선택해주세요');
                return
            }

            if(this.$GlobalStore.loginInfo().is_adult || this.is_family_exist){
                this.showWriteDefulatInfoForm();
                return;
            }

            this.$GlobalStore.addModal('ParentAuth', {completeAction : () => {
                    this.showWriteDefulatInfoForm();
                }, selected_player_type : this.selectedType
            });

        },
        showWriteDefulatInfoForm(){
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { playerType: this.selectedType });
        },
        selectType(type) {
            this.selectedType = type;
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}

.content_container {
    flex: 1;
    padding: 0 25px;
    overflow-y: scroll;
    padding-bottom: 20px;
}

.title {
    font-size: 32px;
    font-weight: 900;
    line-height: 40px;
    margin-top: 24px;
}

.sub_title {
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    color: #808080;
    margin-top: 6px;
}

.type_container {
    margin-top: 26px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.type_box {
    padding: 24px;
    padding-right: 0;
    border-radius: 12px;
    position: relative;
    border: 2px solid #d9d9d9;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.type_box.elite {
    border: 2px solid #e4c7c7;
}

.type_box.challenger {
    border: 2px solid #1C50D033;
}

.box_type {
    border-radius: 4px;
    padding: 0 4px;
    line-height: 24px;
    font-size: 12px;
    font-weight: 700;
    display: inline-block;
}

.box_type.elite_only {
    color: #c11f1f;
    background-color: #FFECEC;
}

.box_type.challenger {
    color: #1c50d0;
    background-color: #1C50D033;
}

.type_box_image {
    margin-right: 12px;
}

.box_type_title {
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
}

.box_type_description {
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #606060;
}

.box_type_description span {
    font-weight: 700;
}

.box_type_description span.highlight_elite {
    color: #C11F1F
}

.box_type_description span.highlight_challenger {
    color: #1C50D0
}

.check_container_wrapper {
    margin-top: 8px;
}

.check_container {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
}

.check_img {
    width: 12px;
}

.check_text {
    font-weight: 500; 
    font-size: 12px;
    line-height: 20px;
    color: #606060;
}

.check_container:first-child {
    margin-top: 0;
}

.footer_container {
    padding: 0 24px;
}

.footer_btn {
    width: 100%;
    text-align: center;
    height: 48px;
    line-height: 48px;
    background-color: #ebebeb;
    color: #d9d9d9;
    font-weight: 700;
    border-radius: 12px;
    margin-bottom: 20px;
    margin-top: 12px;
}

.selected_elite {
    background: #C11F1F1A;
    border: 2px solid #C11F1F
}

.selected_challenger {
    background: #1C50D01A;
    border: 2px solid #1C50D0
}

.active_footer_btn {
    color: #fff;
    background-color: var(--color-main);
}
</style>